import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LeavePageConfirmationDialog = ({ open, onConfirm, onCancel }: Props) => {
  return (
    <SmallDialog open={open}>
      <DialogTitle>Cancel</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ alignItems: "center" }}>
          <WarningDialogIcon sx={{ width: 80, height: 80 }} />
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">Cancel changes?</Typography>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              Your requested changes will be discarded.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onCancel} cancelText="Continue Editing">
        <Button variant="contained" onClick={onConfirm}>
          Close & Leave
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default LeavePageConfirmationDialog;
